import { gql } from '@apollo/client';

export const FETCH_UNAVAILABITY_DAYS = gql`
	query multiQueries($crewMemberId: ID!) {
		crewMemberAbsences(crewMemberId: $crewMemberId) {
			id
			note
			createdAt
			fromTimestamp
			toTimestamp
			updatedBy
			reason {
				id
				name
				isPayable
			}
		}
		crewMemberAbsenceReasons {
			id
			name
			isPayable
		}
	}
`;
